import { render } from "./Intersector.vue?vue&type=template&id=faab30ae"
import script from "./Intersector.vue?vue&type=script&lang=js"
export * from "./Intersector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__